import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams
} from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { AuthService } from '../shared/auth.service';
import { Usuario } from '../models/usuario';
import { environment } from 'src/environments/environment';
import { CatalogoTabla } from '../models/catalogoTablas';
import { HttprService } from '../shared/httpr.service';

@Injectable({ providedIn: 'root' })
export class CatalogoTablaService {
  usuarioLogeado: Usuario;

  constructor(private http: HttpClient, private authService: AuthService, private httpr: HttprService) { }

  recuperaPerfiles(catalogoTabla: CatalogoTabla) {
    this.usuarioLogeado = JSON.parse(localStorage.getItem("usLog"))
    var url = environment.apiUrl;

    let params = new HttpParams();
    params = params.append("IdUsuario", catalogoTabla.idUsuarioUM.toString());
    params = params.append("Tabreg", catalogoTabla.tabreg.toString());

    return this.http.get<CatalogoTabla>((url + "/catalogoTablas/recuperaPerfiles"), {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.usuarioLogeado?.token}`
      }, params: params
    }).pipe(
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }


  recuperaCatalogoTablas(catalogoTabla: CatalogoTabla) {
    return this.httpr.POST<CatalogoTabla[]>("/catalogoTablas/recuperaCatalogosTablas", catalogoTabla);
  }

  recuperaCatalogoTablasCiudades(catalogoTabla: CatalogoTabla){
    return this.httpr.POST<CatalogoTabla[]>("/catalogoTablas/recuperaCatalogosTablasCiudades", catalogoTabla);
  }
}
